module.exports = __webpack_public_path__ + "media/1alB-sh-shnej.083ac495.mp3";